// ComponentMap
import App from '../App';

const ComponentMap = {
    App
};

export default ComponentMap;